import { useEffect, useState } from 'react'

import CaretDown from 'assets/icons/caret-d.svg'

export interface Section {
  title: string
  text: string
}

interface ContentAccordionProps {
  section: Section
  opened?: boolean
}
export const removeHTML = (string: string) =>
  string
    ?.replace(/<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g, '')
    .replaceAll('&amp;', '&')
    .replaceAll('&nbsp;', '')

export const ContentAccordionComponent = ({ section, opened = false }: ContentAccordionProps) => {
  const [open, setOpen] = useState(opened)
  useEffect(() => {
    setOpen(opened)
  }, [opened])
  return (
    <>
      <div className="flex flex-col w-full py-6 font-TCCC group border-solid border-b border-[#D7D7D7] transition-all">
        <h2
          className="text-[16px] font-bold flex justify-between pb-[10px] cursor-pointer"
          onClick={() => setOpen(!open)}
        >
          <span className="mr-3">{removeHTML(section.title)}</span>
          <img src={CaretDown} alt="" className={`transition-transform ${open && 'rotate-180'}`} />
        </h2>
        <p className={`${!open && 'hidden'} mr-[33px]`}>{removeHTML(section.text)}</p>
      </div>
    </>
  )
}
